export var isLoadedInIFrame = () => {
  return window.self !== window.top;
};
var getWindowObj = () => {
  return isLoadedInIFrame() ? window.parent : window;
};
export var postMessage = (messageChannel, action) => {
  try {
    getWindowObj().postMessage(action, '*', [messageChannel.port2]);
  } catch (ex) {
    console.log('Error in postMessage :', ex);
  }
};
export var openBiDirectionalChannel = (params, action) => {
  var messageChannel = new MessageChannel();
  postMessage(messageChannel, action);
  messageChannel.port1.onmessage = event => {
    params.callBackFn(event.data);
  };
};
export var openUniDirectionalChannel = action => {
  var messageChannel = new MessageChannel();
  postMessage(messageChannel, action);
};